import { guideTips } from "@/mocks/webtoons";

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-600">
              <i className="ri-compass-3-fill"></i>
              挑漫指南
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              怎么挑到一部
              <span className="text-primary-600">不烂尾的韩漫</span>
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-700">
              很多人入坑韩漫最大的痛点是「高开低走」。掌握下面几个小技巧，
              再结合本站的评分与榜单，就能大幅降低踩雷概率，把时间花在真正值得看的作品上。
            </p>
            <div className="mt-6 flex flex-col gap-3 text-sm text-foreground-700">
              <p className="inline-flex items-start gap-2">
                <i className="ri-check-double-line mt-0.5 text-lg text-accent-600"></i>
                先看「完结神作」「高分经典」栏目，稳定不踩雷
              </p>
              <p className="inline-flex items-start gap-2">
                <i className="ri-check-double-line mt-0.5 text-lg text-accent-600"></i>
                追连载时关注当前话数与口碑走向，理性入坑
              </p>
              <p className="inline-flex items-start gap-2">
                <i className="ri-check-double-line mt-0.5 text-lg text-accent-600"></i>
                悬疑题材务必留意评论区是否有人提「烂尾预警」
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {guideTips.map((t) => (
              <div
                key={t.title}
                className="rounded-lg bg-background-50 p-5 transition-transform duration-300 hover:-translate-y-1"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${t.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {t.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {t.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}